/*
 * @name: 训练须知、园区服务建议:详情
 * @
 * @Author: 黄晓玲
 * @Date: 2022-11-30 11:39:51
 * @LastEditors: 黄晓玲
 * @LastEditTime: 2022-12-02 14:55:52
 * @Description: 描述
 */
<template>
  <div>
    <div :class="+typeData === 2 ? '' : !!id ? 'padding20' : 'container'">
      <el-row
        :gutter="0"
        :type="+typeData === 1 ? 'flex' : ''"
        :justify="+typeData === 1 ? 'center' : ''"
      >
        <el-col
          :xs="24"
          :sm="+typeData === 2 ? 24 : 21"
          :md="+typeData === 2 ? 24 : 16"
        >
          <div
            v-if="[3013].includes(temp.article_category_id)"
            :class="
              +typeData === 2 || !id || $route.params.id ? 'article_img' : ''
            "
          >
            <img :src="temp.pic" alt="" style="width: 100%" />
          </div>
          <div v-else>
            <div v-if="+typeData === 1" class="title">{{ temp.title }}</div>
            <div
              :class="+typeData === 2 ? 'font' : 'content'"
              v-html="xss(temp.content)"
            ></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import * as acticleApi from "@/api/acticle/acticle";
export default {
  props: {
    id: {
      type: [Number, String],
      default: "",
    },
    typeData: {
      type: [String, Number],
      default: 1,
    },
  },
  data() {
    return {
      temp: {
        id: "",
        title: "",
        content: "",
      },
    };
  },
  created() {
    this.load(this.id || this.$route.params.id);
  },
  methods: {
    load(id) {
      acticleApi
        .read({ id })
        .then((res) => {
          this.temp = res.data;
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.article_img {
  /* padding: 6%; */
  /* background: url("../../../assets/images/home/organization.jpg") top center no-repeat;
  background-size: 100% 100%; */
}
.padding20,
.container {
  padding: 20px;
}

.title {
  padding: 50px 0;
  font-size: 36px;
  border-bottom: 1px solid rgba(244, 244, 244, 1);
  font-weight: 700;
  color: #333333;
  text-align: center;
}
.content {
  padding-top: 20px;
}
.font {
  line-height: 30px;
  text-align: justify;
}

@media only screen and (max-width: 768px) {
  .title {
    font-size: 22px;
    padding: 20px 0;
  }
}
</style>